const STORAGE_PREFIX = 'jurat.tableControl.pageSize';

const getCurrentPathname = () => {
  if (typeof window === 'undefined' || !window.location) {
    return 'unknown';
  }

  return window.location.pathname || '/';
};

const normalizePageSize = pageSize => {
  const numericPageSize = Number(pageSize);

  return Number.isFinite(numericPageSize) && numericPageSize > 0
    ? numericPageSize
    : null;
};

export const getTablePageSizeStorageKey = (
  initialPageSize,
  pageSizeStorageKey
) =>
  `${STORAGE_PREFIX}:${
    pageSizeStorageKey || getCurrentPathname()
  }:${initialPageSize}`;

export const getStoredTablePageSize = (initialPageSize, pageSizeStorageKey) => {
  const fallbackPageSize = normalizePageSize(initialPageSize) || 10;

  if (typeof window === 'undefined' || !window.localStorage) {
    return fallbackPageSize;
  }

  try {
    const storedPageSize = normalizePageSize(
      window.localStorage.getItem(
        getTablePageSizeStorageKey(fallbackPageSize, pageSizeStorageKey)
      )
    );

    return storedPageSize || fallbackPageSize;
  } catch (error) {
    return fallbackPageSize;
  }
};

export const setStoredTablePageSize = (
  nextPageSize,
  initialPageSize,
  pageSizeStorageKey
) => {
  const safePageSize = normalizePageSize(nextPageSize);

  if (!safePageSize || typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  try {
    window.localStorage.setItem(
      getTablePageSizeStorageKey(initialPageSize, pageSizeStorageKey),
      `${safePageSize}`
    );
  } catch (error) {
    // Ignore storage failures; pagination should still work for this visit.
  }
};
